module.exports = __webpack_public_path__ + "img/pc-tab-icon2.f4ac21b8.png";